export default __webpack_public_path__ + "static/O0305-01ad4f570a362099cdb14c6cd86fede2.png";